import { configureStore } from '@reduxjs/toolkit';
import {
  authApi,
  dashboardApi,
  integrationsApi,
  eventLogsApi,
  supportTicketsApi,
  usersApi,
  clientsApi,
  profileApi,
  settingsApi,
  subscriptionPlansApi,
} from '../api/baseApis';
import projectApi from '../api/projectsApi';
import rootReducer from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      dashboardApi.middleware,
      integrationsApi.middleware,
      eventLogsApi.middleware,
      supportTicketsApi.middleware,
      usersApi.middleware,
      clientsApi.middleware,
      profileApi.middleware,
      settingsApi.middleware,
      subscriptionPlansApi.middleware,
      projectApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
